import { FC, useEffect } from "react";
import { Loader } from "@/components";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutesList";
import { useChallengeSlugForRedirect } from "@/features/challenge/hooks/useChallengeSlugForRedirect";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import { Heading } from "@radix-ui/themes";

const TCLTimeTrial: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { data: slug, loading, error } = useChallengeSlugForRedirect("CSGO");

  useEffect(() => {
    if (!loading && slug) {
      navigate(`${siteRoutes["challengesAndSlug"]}${slug}`);
    }
  }, [slug]);

  if (loading) {
    return (
      <Loader>
        <Heading as="h1" size="5">
          Loading TCL Time Trial Challenge
        </Heading>
      </Loader>
    );
  }

  if (error) {
    return <FormErrorMessage isVisible text={error.message} />;
  }

  return null;
};

export default TCLTimeTrial;
